// Global JSON.stringify_safety net.
//
// A handful of app/third-party code paths call JSON.stringify_on values that
// contain circular references or live DOM/React-fiber nodes (e.g. a heading
// element captured into React state). The native call throws
// "Converting circular structure to JSON", which can abort a React commit and
// white-screen the app.
//
// We wrap JSON.stringify_so that the NATIVE implementation is always used
// first (identical output, identical fast path for normal data); only when it
// throws do we transparently fall back to safeStringify. This makes every
// JSON.stringify in the bundle crash-proof without changing behaviour for the
// 99% case.
//
// Imported once (guarded by a flag) from the always-mounted ErrorBoundary so it
// is installed on every page load before any component renders.

import { safeStringify } from "./safeStringify";

const nativeStringify = JSON.stringify.bind(JSON);

if (
  typeof JSON !== "undefined" &&
  (JSON as unknown as { __uniuiSafePatched?: boolean }).__uniuiSafePatched !==
    true
) {
  (JSON as unknown as { __uniuiSafePatched?: boolean }).__uniuiSafePatched =
    true;

  JSON.stringify = function (
    value: unknown,
    replacer?: unknown,
    space?: unknown,
  ): string {
    try {
      return nativeStringify(value as never, replacer as never, space as never);
    } catch {
      return safeStringify(value);
    }
  };
}
